<div ngbDropdown #ngbDropdown="ngbDropdown" [container]="'body'">
  <button
    type="button"
    class="no-style-button toggle-button"
    [class.not-allowed]="isDisabled"
    [disabled]="isDisabled"
    (focus)="onFocus()"
    (blur)="onBlur()"
    ngbDropdownToggle>
    <div class="d-flex align-items-center">
      <div>{{ selectedCountry?.countryCode ?? '' }}</div>
      <img class="toggle-chevron" alt="" [src]="iconSrc$ | async" height="20" width="20" />
    </div>
  </button>
  <div ngbDropdownMenu>
    <button
      type="button"
      (focus)="onFocus()"
      (click)="onCountrySelected(country)"
      ngbDropdownItem
      *ngFor="let country of countryDropdowns | slice : 0 : 2">
      <div class="d-flex gap-2 align-items-center">
        <div [style.width.rem]="1.25">
          <img *ngIf="selectedCountry === country" src="assets/icons/dark-grey/Check.svg" alt="selected" i18n-alt />
        </div>
        <div class="option-name">
          {{ country.countryName }}
        </div>
        <div class="option-prefix">{{ country.prefix }}</div>
      </div>
    </button>
    <hr class="option-separator" />
    <button
      type="button"
      (focus)="onFocus()"
      (click)="onCountrySelected(country)"
      ngbDropdownItem
      *ngFor="let country of countryDropdowns | slice : 2">
      <div class="d-flex gap-2 align-items-center">
        <div [style.width.rem]="1.25">
          <img *ngIf="selectedCountry === country" src="assets/icons/dark-grey/Check.svg" alt="selected" i18n-alt />
        </div>
        <div class="option-name">
          {{ country.countryName }}
        </div>
        <div class="option-prefix">{{ country.prefix }}</div>
      </div>
    </button>
  </div>
</div>

<select
  class="mobile-select-input {{ interactionState$ | async }}"
  [value]="selectedCountry?.countryCode"
  (focus)="onFocus()"
  (blur)="onBlur()">
  <option *ngFor="let country of countryDropdowns" (select)="onCountrySelected(country)">
    {{ country.countryCode }}
  </option>
</select>
